module.exports = __webpack_public_path__ + "img/apply_register_03.50ff8a3c.png";